//import firebase from 'firebase/app';
//import 'firebase/functions';
//import 'firebase/storage';
//import moment from 'moment';
//import Compressor from 'compressorjs'; // for compressing image size before upload
import parentPostService from '@/app-template/lib/services/PostService';

export default {
  ...parentPostService,
}